/* eslint-disable react/prop-types */
import React from 'react';

import {FormHelperText, OutlinedInput} from '@mui/material';

const NumberField = React.forwardRef((props, ref) => {
  const {onChange, error, helperText, ...rest} = props;

  console.log({helperText, error});
  return (
    <>
      <OutlinedInput
        ref={ref}
        sx={{
          ...(error ? {border: '1px solid red'} : {}),
          height: 38,
          fontSize: 12,
          '& .MuiOutlinedInput-input::placeholder': {
            fontSize: 12
          }
        }}
        inputProps={{min: 0}}
        type="number"
        size="small"
        fullWidth
        variant="outlined"
        {...rest}
        onChange={e => onChange(Number(e.target.value))}
      />
      {helperText && error && (
        <FormHelperText error sx={{fontSize: 11, lineHeight: 1.1}}>
          {helperText}
        </FormHelperText>
      )}
    </>
  );
});

export default NumberField;
